import React from 'react';
import styles from './TextArea.module.scss';

const TextArea = ({ label, name, required = false, ...props }) => {
  return (
    <div className={styles.formGroup}>
      <label htmlFor={name}>
        {label}
        {required && '*'}
      </label>
      <textarea id={name} name={name} required={required} {...props} />
    </div>
  );
};

export default TextArea;
